import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    Button,
    useDisclosure,
  } from '@chakra-ui/react'

const ImageModal = (props:any) => {
    const { imageUrl, isOpen, onClose } = props
    return (
      <>
        <Modal isOpen={isOpen} onClose={onClose}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Attached Image</ModalHeader>
            <ModalBody>

            <img 
                src={imageUrl}
                alt="Attachment Image"
            />
            </ModalBody>
  
            <ModalFooter>
              <Button colorScheme='blue' mr={3} onClick={onClose}>
                Close
              </Button>
              <Button colorScheme='blue' mr={3} >
                <a href={imageUrl}>
                Save Image
                </a>
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </>
    )
  }

export default ImageModal;
